import { render, staticRenderFns } from "./ChatManagementMobileView.vue?vue&type=template&id=6668ce32&scoped=true"
import script from "./ChatManagementMobileView.vue?vue&type=script&lang=js"
export * from "./ChatManagementMobileView.vue?vue&type=script&lang=js"
import style0 from "./ChatManagementMobileView.vue?vue&type=style&index=0&id=6668ce32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6668ce32",
  null
  
)

export default component.exports